import { createGlobalStyle, css } from 'styled-components';

import { sans } from './style/sharedValues';
import { normalize } from './style/normalize';
import { colore } from './style/color';
import mediainjector from './style/mediainjector';


const sharedStyles = css`
  ${normalize}
  html {
    color: ${colore.ui.txt};
    overflow-y: scroll;
  }
  body {
    position: relative;
    height: 100%;
    font-family: ${({
      theme: {
        fonts: { body: { fontFamily } = {} } = { body: {} }
      } = { fonts: { body: {} } }
    }) => fontFamily ? fontFamily : sans};
    font-size: 1.8rem;
    ${mediainjector.lt768`
      font-size: 1.5rem;
    `}
  }
  html,
  body,
  #app,
  #___gatsby {
    position: relative;
    height: 100%;
    background-color: ${({ theme: { mainBg } = {} }) => mainBg ? mainBg : colore.ui.mainBg};
    ${mediainjector.print`
      background-color: white;
    `}
  }
  #app > div:first-of-type,
  #___gatsby > div:first-of-type {
    position: relative;
    height: 100%;
  }
  strong {
    font-weight: 700;
  }
  h1,h2, h3, h4 {
    font-family: ${({
      theme: {
        fonts: { titles: { fontFamily } = { }} = {titles: {}}
      } = { fonts: { titles: {} } },
    }) => fontFamily };
    font-weight: ${({
      theme: {
        fonts: { titles: { fontWeight } = { }} = {titles: {}}
      } = { fonts: { titles: {} } },
    }) => fontWeight };
  }
  button {
    font-family: ${({
      theme: {
        fonts: { buttons: { fontFamily } = {} } = { buttons: {} }
      } = { fonts: { buttons: {} } }
    }) => fontFamily ? fontFamily : 'inherit'};
    font-weight: ${({
      theme: {
        fonts: { buttons: { fontWeight } = { }} = {buttons: {}}
      } = { fonts: { buttons: {} } },
    }) => fontWeight ? fontWeight : 'inherit' };
  }
  /* Utilities
   * NB Funzionano solo su html e styled-components
  */
  .smallOnly {
    @media (min-width: 668px) {
      display: none !important;
    }
  }
  .mobileOnly {
    @media (min-width: 1025px) {
      display: none !important;
    }
  }
  .mediumUp {
    @media (max-width: 667px) {
      display: none !important;
    }
  }
  .desktopOnly {
    @media (max-width: 1024px) {
      display: none !important;
    }
  }
  .noSelect {
    user-select: none;
  }
  .noPrint {
    @media print {
      display: none !important;
    }
  }
  .onlyPrint {
    @media not print {
      display: none !important;
    }
  }
`;

sharedStyles.defaultProps = {
  theme: {
    mainBg: 'rgb(240, 240, 240)',
    brand: '#00BBEF',
    fonts: {
      body: {
        fontFamily: sans,
      },
      titles: {
        fontFamily: sans,
        fontWeight: '600',
      },
    },
  },
};

/* eslint no-unused-expressions: 0 */
export const GlobalStyle = createGlobalStyle`
  ${sharedStyles}
  html {
    font-size: 62.5%;
  }
`;
